import { createFileRoute } from '@tanstack/react-router';
import { PersonaDetailPage } from '@/pages/personas/PersonaDetailPage';

export const Route = createFileRoute('/personas/$personaId')({
  component: PersonaDetailRoute,
});

function PersonaDetailRoute() {
  const { personaId } = Route.useParams();
  return <PersonaDetailPage personaId={personaId} />;
}
